export default __webpack_public_path__ + "static/media/menu_upload_beat_okara.fa1901e3.svg";